import React from 'react';
import { SvgIcon } from "@material-ui/core";

export const WarningIcon = (props: any) => {
  return (
    <SvgIcon {...props} width="19" height="18" viewBox="0 0 19 18">
      <path fill="#FFF" fillRule="nonzero" d="M18.854 15.752L10.54.632A1.172 1.172 0 0 0 9.5.017c-.44 0-.83.23-1.04.613L.146 15.751c-.201.37-.194.804.02 1.164.214.365.597.582 1.021.582h16.625c.425 0 .808-.217 1.023-.582.213-.36.22-.795.019-1.163zM9.312 6.114a1.136 1.136 0 0 1 1.312.926c.022.126.02.253 0 .372l-.75 4.451a.38.38 0 0 1-.749 0l-.749-4.451a1.129 1.129 0 0 1 .936-1.298zm.188 9.104c-.629 0-1.14-.512-1.14-1.14 0-.629.511-1.14 1.14-1.14.628 0 1.14.511 1.14 1.14 0 .628-.512 1.14-1.14 1.14z"/>
    </SvgIcon>
  );
};